import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import '../../styles/layout.css';

const MOBILE_NAV_ITEMS = [
  { to: '/', label: 'Overview', icon: 'bi-speedometer2', end: true },
  { to: '/data', label: 'Data', icon: 'bi-database' },
  { to: '/schedule', label: 'Schedule', icon: 'bi-calendar-check' },
  { to: '/logs', label: 'Logs', icon: 'bi-terminal' },
  { to: '/settings', label: 'Settings', icon: 'bi-gear' },
];

const MainLayout = () => {
  return (
    <div className="app-shell">
      {/* Desktop sidebar — hidden on mobile via CSS */}
      <Sidebar />

      {/* Main body: topbar + scrollable content */}
      <div className="main-body">
        <TopBar />
        <main className="main-content">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom tab bar — visible only at <= 768px via CSS */}
      <nav className="mobile-tabbar" aria-label="Mobile navigation">
        {MOBILE_NAV_ITEMS.map(({ to, label, icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `mobile-tabbar-item${isActive ? ' active' : ''}`
            }
            aria-label={label}
          >
            <i className={`bi ${icon} mobile-tabbar-item-icon`} aria-hidden="true" />
            <span className="mobile-tabbar-item-label">{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default MainLayout;
